type TokensType = {
  value: string;
  label: string;
  tokenKey: string;
  isVisible: boolean;
};

export type ButtonType = {
  value: string;
  label: string;
  isVisible: boolean;
  isRiskSettings?: boolean;
  isPortfolioPerformance?: boolean;
  position?: number;
  isDefault?: boolean;
  disabled?: boolean;
};

export const TOKENS: TokensType[] = [
  { value: 'BTCUSD', label: 'BTC', isVisible: true, tokenKey: 'btc_usd' },
  { value: 'ETHUSD', label: 'ETH', isVisible: true, tokenKey: 'eth_usd' },
  { value: 'SOLUSDC', label: 'SOL', isVisible: true, tokenKey: 'sol_usdc' },
  { value: 'MATICUSDC', label: 'MATIC', isVisible: true, tokenKey: 'matic_usdc' },
  { value: 'XRPUSDC', label: 'XRP', isVisible: true, tokenKey: 'xrp_usdc' },
  { value: 'BTCUSDC', label: 'BTCUSDC', isVisible: true, tokenKey: 'btc_usdc' },
  { value: 'BTCUSDT', label: 'BTCUSDT', isVisible: true, tokenKey: 'btc_usdt' },
  { value: 'ETHUSDC', label: 'ETHUSDC', isVisible: true, tokenKey: 'eth_usdc' },
  { value: 'ETHUSDT', label: 'ETHUSDT', isVisible: true, tokenKey: 'eth_usdt' },
  { value: 'EOSUSD', label: 'EOSUSD', isVisible: true, tokenKey: 'eos_usd' },
  { value: 'BCHUSDC', label: 'BCH', isVisible: true, tokenKey: 'bch_usdc' },
  { value: 'NEARUSDC', label: 'NEAR', isVisible: true, tokenKey: 'near_usdc' },
  { value: 'AVAXUSDC', label: 'AVAX', isVisible: true, tokenKey: 'avax_usdc' },
  { value: 'LTCUSDC', label: 'LTC', isVisible: true, tokenKey: 'ltc_usdc' },
  { value: 'DOGEUSDC', label: 'DOGE', isVisible: true, tokenKey: 'doge_usdc' },
  { value: 'DOTUSDC', label: 'DOT', isVisible: true, tokenKey: 'dot_usdc' },
  { value: 'LINKUSDC', label: 'LINK', isVisible: true, tokenKey: 'link_usdc' },
  { value: 'ADAUSDC', label: 'ADA', isVisible: true, tokenKey: 'ada_usdc' },
  { value: 'TRXUSDC', label: 'TRX', isVisible: true, tokenKey: 'trx_usdc' },
  { value: 'ALGOUSDC', label: 'ALGO', isVisible: true, tokenKey: 'algo_usdc' },
  { value: 'UNIUSDC', label: 'UNI', isVisible: true, tokenKey: 'uni_usdc' },
  { value: 'BNBUSD', label: 'BNB', isVisible: true, tokenKey: 'bnb_usd' },
  { value: 'USDCUSD', label: 'USDC', isVisible: true, tokenKey: 'usdc_usd' },
  { value: 'USDTUSD', label: 'USDT', isVisible: true, tokenKey: 'usdt_usd' },
];

export const TOKEN_LIST: ButtonType[] = [
  { value: 'BTCUSD', label: 'BTC', isVisible: true },
  { value: 'ETHUSD', label: 'ETH', isVisible: true },
  { value: 'SOLUSDC', label: 'SOL', isVisible: true },
  { value: 'MATICUSDC', label: 'MATIC', isVisible: true },
  { value: 'XRPUSDC', label: 'XRP', isVisible: true },
  { value: 'BTCUSDC', label: 'BTCUSDC', isVisible: true },
  { value: 'BTCUSDT', label: 'BTCUSDT', isVisible: true },
  { value: 'ETHUSDC', label: 'ETHUSDC', isVisible: true },
  { value: 'ETHUSDT', label: 'ETHUSDT', isVisible: true },
  { value: 'BCHUSDC', label: 'BCH', isVisible: true },
  { value: 'NEARUSDC', label: 'NEAR', isVisible: true },
  { value: 'AVAXUSDC', label: 'AVAX', isVisible: true },
  { value: 'LTCUSDC', label: 'LTC', isVisible: true },
  { value: 'DOGEUSDC', label: 'DOGE', isVisible: true },
  { value: 'DOTUSDC', label: 'DOT', isVisible: true },
  { value: 'LINKUSDC', label: 'LINK', isVisible: true },
  { value: 'ADAUSDC', label: 'ADA', isVisible: true },
  { value: 'TRXUSDC', label: 'TRX', isVisible: true },
  { value: 'ALGOUSDC', label: 'ALGO', isVisible: true },
  { value: 'UNIUSDC', label: 'UNI', isVisible: true },
  { value: 'BNBUSD', label: 'BNB', isVisible: true },
];

export const RISK_TOKEN_LIST = [
  { value: 'QUOTE', label: 'Quote', isVisible: true },
  { value: 'BASE', label: 'Base', isVisible: true },
];

export const VENUE_TYPE_LIST = [
  { value: 'deribit', label: 'Deribit', isVisible: true },
  { value: 'okx', label: 'OKX', isVisible: true },
];

export const VOL_SHOCK_LIST: ButtonType[] = [
  { value: '-0.75', label: '-75%', isVisible: true },
  { value: '-0.5', label: '-50%', isVisible: true },
  { value: '-0.25', label: '-25%', isVisible: true },
  { value: '-0.1', label: '-10%', isVisible: true },
  { value: '0', label: '0%', isVisible: true, isDefault: true },
  { value: '0.1', label: '10%', isVisible: true },
  { value: '0.25', label: '25%', isVisible: true },
  { value: '0.5', label: '50%', isVisible: true },
  { value: '0.75', label: '75%', isVisible: true },
  { value: '1.0', label: '100%', isVisible: true },
  { value: '1.25', label: '125%', isVisible: true },
  { value: '1.5', label: '150%', isVisible: true },
];

export const VOL_SHOCK_REAL_RISK: ButtonType =
  VOL_SHOCK_LIST.find((vs) => vs.value === '0') || VOL_SHOCK_LIST[0];

export const TIME_LIST: ButtonType[] = [
  { value: '0D', label: 'T+0', isVisible: true, isDefault: true },
  { value: '1D', label: 'T+1', isVisible: true },
  { value: '2D', label: 'T+2', isVisible: true },
  { value: '3D', label: 'T+3', isVisible: true },
  { value: '4D', label: 'T+4', isVisible: true },
  { value: '5D', label: 'T+5', isVisible: true },
];

export const OTC_TRADER_TENOR_LIST: any[] = [
  { value: '1D', label: '1D', position: 1, isVisible: true },
  { value: '2D', label: '2D', position: 2, isVisible: true },
  { value: '3D', label: '3D', position: 3, isVisible: true },
  { value: '1W', label: '1W', position: 4, isVisible: true },
  { value: '2W', label: '2W', position: 5, isVisible: true },
  { value: '1M', label: '1M', position: 6, isVisible: true },
  { value: '2M', label: '2M', position: 7, isVisible: true },
  { value: '3M', label: '3M', position: 8, isVisible: true },
  { value: '6M', label: '6M', position: 9, isVisible: true },
  { value: '9M', label: '9M', position: 10, isVisible: true },
  { value: '1Y', label: '1Y', position: 11, isVisible: true },
  { value: '2Y', label: '2Y', position: 12, isVisible: true },
];

export const OTC_TRADER_DELTA_LIST: any[] = [
  {
    value: ['ATMF', '10P', '25P', '25C', '10C'],
    label: 'ATMF, 10P, 25P, 25C, 10C',
    isVisible: true,
    id: 'delta_1',
  },
  {
    value: ['ATMF', '25RR', '25FLY', '10RR', '10FLY'],
    label: 'ATMF, 25RR, 25FLY, 10RR, 10FLY',
    isVisible: true,
    id: 'delta_2',
  },
  {
    value: ['ATMF', '25RR', '25FLY', '10/25RR', '10/25FLY'],
    label: 'ATMF, 25RR, 25FLY, 10/25RR, 10/25FLY',
    isVisible: true,
    id: 'delta_3',
  },
];

export const RISK_METRIC_LIST: ButtonType[] = [
  { value: 'PV', label: 'PV', isVisible: true, isRiskSettings: true, position: 1 },
  { value: 'PNL', label: 'PNL', isVisible: true, isRiskSettings: true, position: 2 },
  { value: 'INTRINSIC', label: 'Intrinsic', isVisible: true, isRiskSettings: true, position: 3 },
  {
    value: 'INTRINSIC (QUOTE)',
    label: 'Intrinsic (Quote)',
    isVisible: true,
    isRiskSettings: true,
    position: 4,
  },
  {
    value: 'INTRINSIC (BASE)',
    label: 'Intrinsic (Base)',
    isVisible: true,
    isRiskSettings: true,
    position: 5,
  },
  { value: 'TIMEVALUE', label: 'TimeValue', isVisible: false, isRiskSettings: true, position: 6 },
  { value: 'DELTA', label: 'Delta', isVisible: true, isRiskSettings: true, position: 7 },
  {
    value: 'INTRINSIC_DELTA',
    label: 'Intrinsic Delta',
    isVisible: true,
    isRiskSettings: true,
    position: 8,
  },
  { value: 'GAMMA', label: 'Gamma', isVisible: true, isRiskSettings: true, position: 9 },
  { value: 'THETA', label: 'Theta', isVisible: true, isRiskSettings: true, position: 10 },
  { value: 'VEGA', label: 'Vega', isVisible: true, isRiskSettings: true, position: 11 },
  { value: 'VOLGA', label: 'Volga', isVisible: true, isRiskSettings: true, position: 12 },
  { value: 'VANNA', label: 'Vanna', isVisible: true, isRiskSettings: true, position: 13 },
  {
    value: 'VEGA(WEIGHTED)',
    label: 'Vega (Weighted)',
    isVisible: true,
    isRiskSettings: true,
    position: 14,
  },
  {
    value: 'GAMMA(THEO)',
    label: 'Gamma (Theo)',
    isVisible: true,
    isRiskSettings: true,
    position: 15,
  },
  {
    value: 'DVEGADSPOT',
    label: 'DVegaDSpot',
    isVisible: true,
    isRiskSettings: true,
    position: 16,
  },
  {
    value: 'DDELTADVOL',
    label: 'DDeltaDVol',
    isVisible: true,
    isRiskSettings: true,
    position: 17,
  },
  {
    value: 'SETTLEMENT (BASE)',
    label: 'Settlement (BASE)',
    isVisible: true,
    isRiskSettings: true,
    position: 18,
  },
  {
    value: 'SETTLEMENT (QUOTE)',
    label: 'Settlement (QUOTE)',
    isVisible: true,
    isRiskSettings: true,
    position: 19,
  },
  {
    value: 'SMILE_25',
    label: 'Smile 25',
    isVisible: true,
    isRiskSettings: true,
    position: 20,
  },
  {
    value: 'SKEW_25',
    label: 'Skew 25',
    isVisible: true,
    isRiskSettings: true,
    position: 21,
  },
  {
    value: 'DELTA(STICKY_DELTA)',
    label: 'Delta (Sticky Delta)',
    isVisible: true,
    isRiskSettings: true,
    position: 22,
  },
];

// A disabled risk metric is greyed in the UI but must never reach the risk
// request: the backend fails the ENTIRE run when asked for a metric it does not
// define (e.g. DELTA(STICKY_DELTA) on a backend without sticky-delta). Scrub it
// at every send-site so neither a fresh default nor a persisted selection can
// leak a disabled metric into the payload.
const DISABLED_RISK_METRICS = new Set(
  RISK_METRIC_LIST.filter((metric) => metric.disabled).map((metric) => metric.value),
);

export const excludeDisabledRiskMetrics = (values: string[]): string[] =>
  values.filter((value) => !DISABLED_RISK_METRICS.has(value));

export const CONTRACT_KEYS = [
  { value: 'PERPETUAL', label: 'Perpetual', isVisible: true },
  { value: 'FUTURE', label: 'Future', isVisible: true },
  { value: 'OPTION', label: 'Option', isVisible: true },
  { value: 'CASH', label: 'Cash', isVisible: true },
];

export const CONTRACT_VALUES = ['PERPETUAL', 'FUTURE', 'OPTION', 'CASH'];

export const PORTFOLIO_CONTRACTS = {
  RISK: {
    CONTRACT_KEYS: [
      { value: 'PERPETUAL (INVERSE)', label: 'Perpetuals (Inverse)', isVisible: true },
      { value: 'PERPETUAL (LINEAR)', label: 'Perpetuals (Linear)', isVisible: true },
      { value: 'FUTURE', label: 'Future', isVisible: true },
      { value: 'OPTION', label: 'Option', isVisible: true },
      { value: 'CASH', label: 'Cash', isVisible: true },
    ],
    CONTRACT_VALUES: ['PERPETUAL (INVERSE)', 'PERPETUAL (LINEAR)', 'FUTURE', 'OPTION', 'CASH'],
  },
  POSITIONS: {
    CONTRACT_KEYS,
    CONTRACT_VALUES,
  },
  TRANSACTIONS: {
    CONTRACT_KEYS: [...CONTRACT_KEYS, { value: 'SPOT', label: 'Spot', isVisible: true }],
    CONTRACT_VALUES: [...CONTRACT_VALUES, 'SPOT'],
  },
};

export const EVENT_TYPES_TRANSACTIONS = [
  { value: 'trade', label: 'Trade', isVisible: true },
  { value: 'delivery', label: 'Delivery', isVisible: true },
  { value: 'settlement', label: 'Settlement', isVisible: true },
  { value: 'position_move', label: 'Position move', isVisible: true },
  { value: 'transfer_funds', label: 'Transfer funds', isVisible: true },
  { value: 'fee_deposit', label: 'Fee deposit', isVisible: true },
  { value: 'SWAP', label: 'SWAP', isVisible: true },
];

export const EVENT_TYPES_TRANSACTIONS_VALUES = [
  'trade',
  'delivery',
  'settlement',
  'position_move',
  'transfer_funds',
  'fee_deposit',
  'instrument_type',
  'envent_type',
  'counterparty_exercised',
];
